import { forwardRef } from "react";
import { Trigger as TriggerPrimitive } from "@radix-ui/react-dialog";

export const Trigger = forwardRef<
  React.ElementRef<typeof TriggerPrimitive>,
  React.ComponentPropsWithoutRef<typeof TriggerPrimitive>
>(({ className, ...props }, ref) => <TriggerPrimitive ref={ref} {...props} />);

Trigger.displayName = TriggerPrimitive.displayName;

export default Trigger;
